(ns machtfit.widgets.badge
  (:require
   [machtfit.widgets.icon :as icon]))

(defn size-classes [size]
  (case size
    :sm ["h-5"
         "px-2"
         "py-0.5"
         "text-xs"]
    :md ["h-6"
         "px-2.5"
         "py-0.5"
         "text-sm"]
    :lg ["h-7"
         "px-3"
         "py-1"
         "text-sm"]))

(defn pill-outline-color-classes [color]
  (case color
    :gray ["bg-gray-25" "border-gray-100" "text-gray-800"]
    :error ["bg-error-50" "border-error-200" "text-error-600"]
    :brand ["bg-brand-50" "border-brand-200" "text-brand-600"]
    :raspberrypink ["bg-raspberrypink-500" "border-raspberrypink-500" "text-white"]
    :wellhub ["bg-[#F2496B]" "border-[#F2496B]" "text-white"]
    :mindance ["bg-[#C8D302]" "border-[#C8D302]" "text-black"]))

(defn pill-outline [{:keys [text
                            size
                            color
                            on-click
                            classes
                            inline-styles
                            icon-leading
                            icon-attrs]
                     :or {color :gray
                          size :md}}]
  [:span {:class
          (concat (pill-outline-color-classes color)
                  (size-classes size)
                  classes
                  ["w-fit"

                   "justify-start"
                   "items-center"
                   "gap-1"
                   "inline-flex"

                   "rounded-full"
                   "border"

                   "whitespace-nowrap"])
          :on-click (fn [e]
                      (when on-click
                        (.stopPropagation e)
                        (.preventDefault e)
                        (on-click)))
          :style inline-styles}
   (when icon-leading
     [icon/outline icon-leading (merge {:width "w-3"
                                        :height "h-3"}
                                       icon-attrs)])
   text])

(defn pill-filled-color-classes [color]
  (case color
    :unset []
    :gray ["bg-gray-500" "text-white"]
    :brand ["bg-brand-500" "text-white"]
    :error ["bg-error-500" "text-white"]
    :warning ["bg-warning-500" "text-white"]))

(defn pill-filled [{:keys [text
                           size
                           color
                           on-click
                           classes
                           inline-styles
                           icon-leading]
                    :or {color :gray
                         size :md}}]
  [:span {:class
          (concat (pill-filled-color-classes color)
                  (size-classes size)
                  classes
                  ["w-fit"

                   "justify-start"
                   "items-center"
                   "gap-1"
                   "inline-flex"

                   "rounded-full"

                   "whitespace-nowrap"])
          :on-click (fn [e]
                      (when on-click
                        (.stopPropagation e)
                        (.preventDefault e)
                        (on-click)))
          :style inline-styles}
   (when icon-leading
     [icon/outline icon-leading {:width "w-3"
                                 :height "h-3"}])
   text])
